
// 计算平方米
// 添加到列表
// 列表里面存储经纬度getojson
// 细节调整
// 颜色调整
const wellknown = require("wellknown");
import { doExportReportReport, doReportData } from '@/api/enterprise'
import layerContent from './project-layer-content'
import config from '@/config'
import dayjs from 'dayjs'
import reportBtnPptx from './report-btn-pptx'
import reportBtnPdf from './report-btn-pdf'
import cesuanBtn from './cesuan-btn'
export default {
  components: {reportBtnPdf,reportBtnPptx, cesuanBtn},
  props: ['info'],
  data() {
    return {
      isManualCalculate: false,
      isExportingCalculate: false,
      project_id: null,
      project_name: null,
      draw: null,
      totalArea: 0, // 面积
      totalAreaInMu: 0,
      totalAreaInHectares: 0,
      borderValue: 0,
      widget: null,
      polygonsArrs: [],
      tableData: [],
      mapmeasureDrawTool: null,
      boxPopupWindow: [],
      isLine: true,      
      lineType: 2,
      activeId: "", // 当前选择的图形id
      activeType: "line", // 当前选择的图形类型
      borderStyles: [
        { id: 0, name: "实线", classest: "solid-line",  value: '' },
        { id: 1, name: "虚线", classest: "dashed-line", value: [0.2, 2] },
        { id: 2, name: "点线", classest: "dotted-line", value: [0.1, 2] },
      ], // 线条样式
      lineStrokeColor: "#ff0000", // 线条的轮廓颜色
      lineBorderStyle: 0, // 线条的样式，实线、虚线等      
      lineOpacity: 1, // 线条的透明度
      opacity: 50,
      shapeFillColor: "#00ff00", // 形状的填充颜色
      shapeStrokeColor: "#ff0000", // 形状的轮廓颜色
      shapeStrokeColorOther: "", // 形状的轮廓颜色
      lineBorderWidth: 2, // 线条的宽度
      shapeBorderWidth: 1, // 形状的边框线宽度
      shareOpacity: 0.5, // 形状的透明度
      fontContent: "", // 文字的内容
      fontColor: "#ff0000", // 文字的颜色
      fontSize: 18, // 文字的大小
      fontOpacity: 0.8,
      pointRadius: 3, // 点大小，半径
      pointColor: "#00ff00", // 点颜色
      pointOpacity: 1,
    };
  },

  computed: {
    // 预定义颜色
    predefineColors() {
      return "#000000";
    },
    styleConfig() {
      return {
        lineBorderStyle: this.lineBorderStyle,
        lineStrokeColor: this.lineStrokeColor,
        lineBorderWidth: this.lineBorderWidth,
        lineOpacity: this.lineOpacity,
        shapeFillColor: this.shapeFillColor,
        shapeStrokeColor: this.shapeStrokeColor,
        shapeBorderWidth: this.shapeBorderWidth,
        shareOpacity: this.shareOpacity,
        fontContent: this.fontContent,
        fontColor: this.fontColor,
        fontSize: this.fontSize,
        fontOpacity: this.fontOpacity,
        pointRadius: this.pointRadius,
        pointColor: this.pointColor,
        pointOpacity: this.pointOpacity,
        drawType: "POLYLINE",
      };
    },
  },
  destroyed() {

  },
  watch: {
    styleConfig(newVal, oldValue) {        
      this.widget && this.widget.updateDrawStyle(newVal);
      // map.getSource('trace').setData(data);
    },
  },
  mounted() {
    this.widget = window.widget
    this.draw = window.widget.plotManager.draw 
  },
  methods: {  
    // 手动测算状态
    doManualCalculate(state) {
      this.isManualCalculate = state
      $('#setProjectDefaultNameBtn').click()
    },
    exportingCalculate(state) {
      this.isExportingCalculate = state   
      $('#setProjectDefaultNameBtn').click()
    },   
    exportingPPTX(state) {
      this.isExportingPPTX = state   
      $('#setProjectDefaultNameBtn').click() 
    },
    exportingPDF(state) {
      this.isExportingPDF = state   
      $('#setProjectDefaultNameBtn').click()   
    }, 
    putData() {      
       let data = $('#attr_put_data').data('attr_data')              
       if (data) {
          data = JSON.parse(data)          
          let geojson = {
            "type": "Feature",
            "properties": {},
            "geometry": {
              "type": JSON.parse(data[0].st_asgeojson)['type'] == 'MultiPolygon' ? 'MultiPolygon' : "Polygon",
              "coordinates": JSON.parse(data[0].st_asgeojson).coordinates
            }
          }              
          const fetId = this.draw.mapboxDraw.add(geojson);
          let polygon = this.draw.mapboxDraw.get(
            fetId
          );
          this.tableData.push({
              type: '面',
              POLYGON: polygon
          })
          this.widget.updateDrawStyle(this.styleConfig)
          this.calcArea(this.draw)
       }
       
    },  
    async confirmSave() {
      let arr = []  
      let style = {} 
      let that = this
      this.tableData.forEach( item => {
        arr.push(item.POLYGON)
      })         
      style = this.styleConfig 
           
      let {project_id, project_name } = await this.$parent.saveProject(this.convertToWKT(arr), style)
      this.project_id = project_id
      this.project_name = project_name
      if (this.isExportingPDF) {
        this.$store.commit('app/SET_PROJECT_ID', this.project_id)   
        this.$store.commit('app/SET_PROJECT_LOADING', true)     
        $('#doReportProjectBtn').click()
        this.isExportingPDF = false
      } else if (this.isExportingPPTX) {
        this.$refs.reportBtnPptxRef.showLoading()
        this.$store.commit('app/SET_PROJECT_ID', this.project_id)  
        const res = await doExportReportReport({project_id: this.project_id, format: 'pptx'})
        this.$refs.reportBtnPptxRef.hideLoading()  
        this.isExportingPPTX = false   
        if (res.code == 0) {
          fetch(process.env.NODE_ENV === "dev" ?  res.data.url.replace('https://cyy.pcmxj.com', '/json') : res.data.url)        
          .then(response => response.blob())
          .then(blob => {          
            saveAs(blob, `${this.project_name}.pptx`);
          });
        }        
      } else if (this.isExportingCalculate) {
        this.isExportingCalculate = false        
        const res = await doReportData({project_id: this.project_id})
        fetch(`${config.SSR_API_URL}/sheet/exporReportData`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({"setCoordinate": {'0 填写表': {}, ...res.data.setCoordinate } }  )
          }).then(response => {
            if (response.ok) {
              return response.blob();
            } else {
              throw new Error("Error: " + response.statusText);
            }
          }).then(blob => {
            var fileName =  `${that.project_name}-经济测算${dayjs().format('YYYY年MM月DD日 HH时mm分ss秒')}.xlsx`; 
            that.$store.commit('app/SET_CESUAN_LOADING', false)
            saveAs(blob, fileName);
            if ( process.client ) {
              this.$toasted.success('操作成功!',{position: "top-center", duration: 2000})
              that.$layer.close(window.lacusuanBtn)
            }
            
          }).catch(error => {
            that.$store.commit('app/SET_CESUAN_LOADING', false)
          });                
      } else if (this.isManualCalculate) {
          this.isManualCalculate = false
          this.$layer.iframe({
            content: {
              content: layerContent, //传递的组件对象
              parent: this,//当前的vue对象      
              data: {              
                cesuanTitle: this.project_name,
                project_id: this.project_id
              }
            },
            isOutAnim: false,
            maxmin: true,
            time: 0,
            shadeClose: false,
            resize: true,
            scrollbar: false,
            area:['1200px','650px'],
            title: '2222',
            skin: 'custom-layer-class',
            cancel: function() {
            }
          });
      }
      
    },
    indexMethod(index) {
        return index + 1;
    },
    convertToWKT(features) {
      
      const polygons = [];

      features.forEach(feature => {
        const geometry = feature.geometry;

        if (geometry.type === 'MultiPolygon') {
          geometry.coordinates.forEach(coordinate => {
            polygons.push(turf.polygon(coordinate));
          });
        }

        if (geometry.type === 'Polygon') {
          polygons.push(turf.polygon(geometry.coordinates));
        }
      });

      // const multiPolygon = turf.multiPolygon(polygons.map(polygon => polygon.geometry.coordinates));
      const multiPolygon = polygons.reduce( (acc, polygon ) => {
          return turf.union(acc,  polygon);
      }, polygons[0])      
      const wkt = wellknown.stringify(multiPolygon);
      return wkt
    },
    drawUpdate() {
      this.$parent.building.off('draw.update')
      this.$parent.building.on('draw.update', (event) =>{
          // 事件对象包含了所有被更新的特征
           this.calcArea(this.draw)
           this.tableData.forEach( item => {
              if (item.POLYGON.id == event.features[0].id) {
                item.POLYGON = event.features[0]
              }
           })          
      })
    },
    getCurrentRow(row) {                 
      this.draw.mapboxDraw.changeMode('direct_select', {
          featureId: row.POLYGON.id
      })
    },
    delRow(row) {         
      this.draw.mapboxDraw.delete(row.POLYGON.id)   
      const idx = this.tableData.findIndex( item => item.POLYGON.id == row.POLYGON.id )         
      this.tableData.splice(idx, 1)
      this.calcArea(this.draw)
    },
    calcArea(draw) {
        let featuresArr = draw.mapboxDraw.getAll()        
        let totalArea = 0;
        featuresArr.features.forEach(  (feature) => {
            const area = turf.area(feature);
            totalArea += area;
        })
        this.totalArea = totalArea.toFixed(2)
        this.totalAreaInHectares = (totalArea / 10000).toFixed(2) ;
        this.totalAreaInMu = ( totalArea / 666.67 ).toFixed(2);
    },
    showTheLine() {                       
        if (this.isLine) {                                   
            this.shapeStrokeColor =  this.shapeStrokeColorOther        
        } else {
            this.shapeStrokeColorOther = this.shapeStrokeColor 
            this.shapeStrokeColor = 'transparent'             
        }        
    }

  },
};
